export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const RESET_PRODUCT = 'RESET_PRODUCT';
export const SET_PRODUCTS = 'SET_PRODUCTS';
